import { sendGet } from "./axios";

export const dailyReport = (params: { date: string }) =>
  sendGet("/daily-report", params);
